import {
  getRejectCandidateProcess,
  getCalculatePercentileAction,
  getEditApplicationAction,
  getRejectApplicationAction,
  hasRejectionDecision,
} from './shared';
import type { ActiveProcessesItem } from 'framework/ViewTypes/embeddable';
import type { ApplicationDetails, ApplicationStageActions } from '../../shared/types';
import type { CreateApplicationStageConfig } from './types';

const getOfferProcess = ({ offers }: ApplicationDetails, actions: ApplicationStageActions): ActiveProcessesItem => ({
  id: 'make-offer',
  title: 'Prepare offer',
  action: offers?.length
    ? { id: 'review-offer', label: 'Review offer', variant: 'contained', onClick: actions.reviewOffer }
    : { id: 'create-offer', label: 'Create offer', variant: 'contained', onClick: actions.createOffer },
});

export const createQualifiedStageConfig: CreateApplicationStageConfig = actions => ({
  badge: { id: 'qualified', label: 'Qualified', color: 'info' },
  getAttributes: () => [],
  getActions: () => [
    getRejectApplicationAction(actions),
    getEditApplicationAction(actions),
    getCalculatePercentileAction(actions),
  ],
  getActiveProcessesProps: application => ({
    collapsible: false,
    items: hasRejectionDecision(application)
      ? [getRejectCandidateProcess(actions)]
      : [getOfferProcess(application, actions)],
  }),
});
